<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction" ref="userMoneyTableRef" >
    </wt-form-table>
  </div>
</template>

<script>
export default {
  name: 'UserMoneyList',
  props: ['userid'],
  data() {
    return {
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_USER_MONEY_LIST',
        formComponent: {
          list: { type: 'default', value: '/modules/ablUserFinanceStats/dataList', params: { userId: this.userid }}
        },
        formInputsData: [],
        formButtonsData: [[{ name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userIntegralDetails/userIntegralListImport',
          fileName: '资金管理',
          permission: 'EXPORT' }]],
        formTableData: [
          { name: '公司名称', key: 'companyName', type: 'text' },
          { name: '用户id', key: 'userId', type: 'text' },
          { name: '提现金额(元)', key: 'withdrawDeposit', type: 'text' },
          { name: '充值金额(元)', key: 'topUp', type: 'text' },
          { name: '开箱金额(元)', key: 'collectorPayment', type: 'text' },
          { name: '分润金额(千克)', key: 'netProfit', type: 'text' },
          { name: '投递金额(元)', key: 'userReceivedAmount', type: 'text' },
          { name: '创建时间', key: 'createdAt', type: 'text' }],
        formTableButtonsData: [],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: false, index: false, buttonHidden: false }
      }
    }
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      const that = this
      if (data && data.item) {
      }
    }
  }
}
</script>
